var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "body" } }, [
      _c("section", { attrs: { id: "header" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 text-center" }, [
              _c("h1", { attrs: { "data-aos": "fade-up" } }, [
                _vm._v("รางวัลผู้ให้บริการยอดเยี่ยม :")
              ]),
              _vm._v(" "),
              _c("p", { attrs: { "data-aos": "fade-up" } }, [
                _vm._v(
                  "\n            โครงการผู้ให้บริการยอดเยี่ยม คือโครงการที่ช่วยสนับสนุนและโปรโมทคุณแม่บ้านชั้นนํา\n            ที่สามารถให้บริการเกินมาตรฐาน"
                ),
                _c("br"),
                _vm._v(
                  "\n            และสร้างความประทับใจสูงสุดให้กับลูกค้าของตนเอง\n          "
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "d-md-block",
          attrs: {
            src: "/static/img/excellent/cover.png",
            alt: "",
            "data-aos": "fade-up"
          }
        })
      ]),
      _vm._v(" "),
      _c("section", { attrs: { id: "benefit-service" } }, [
        _c("div", { staticClass: "top-description" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 text-center content" }, [
                _c("h1", { attrs: { "data-aos": "fade-up" } }, [
                  _vm._v("ประโยชน์จากการเป็นผู้ให้บริการยอดเยี่ยม")
                ]),
                _vm._v(" "),
                _c("p", { attrs: { "data-aos": "fade-up" } }, [
                  _vm._v(
                    "\n              หากคุณได้รับรางวัลผู้ให้บริการยอดเยี่ยม คุณมีโอกาสที่จะได้รับการจองจากคุณลูกค้าที่มากกว่า\n              เนื่องจากในโปรไฟล์ของคุณ"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n              จะมีสัญลักษณ์การันตีคุณภาพโดย BeNeat ซึ่งลูกค้าส่วนใหญ่จะมองหาผู้ให้บริการที่มีคุณภาพสูงก่อน\n            "
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "middle-icon text-center" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              "data-aos": "fade-down",
              src: "/static/img/excellent/Award.png",
              alt: ""
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "description-content" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-12 col-md-6",
                  attrs: { "data-aos": "fade-up" }
                },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: "/static/img/excellent/more_work.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(
                      "\n              มีโอกาสได้รับงานที่มากกว่า\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n              BeNeat มีการทําการตลาดเพื่อแนะนําผู้ให้บริการยอดเยี่ยม ผ่านทาง Email, แอปพลิเคชั่นและอีกหลายๆ\n              ช่องทาง มีกระทั่งตัวกรองการค้นหาคุณแม่บ้านเพื่อให้คุณลูกค้าสามารถหาคุณได้อย่างง่ายดาย"
                    ),
                    _c("br"),
                    _vm._v(
                      "และเรายังได้เพิ่มตราสัญลักษณ์ผู้ให้บริการยอดเยี่ยมลงในโปรไฟล์ของคุณอีกด้วย\n              ซึ่งรับรองได้ว่าคุณจะโดดเด่นจริงๆ\n            "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 col-md-6 add-margin",
                  attrs: { "data-aos": "fade-up" }
                },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: { src: "/static/img/excellent/proudly.png", alt: "" }
                  }),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(
                      "\n              เข็มกลัดแห่งความภูมิใจ\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n              ผู้ให้บริการยอดเยี่ยมจะได้รับ เข็มกลัดแห่งความภูมิใจ\n              ซึ่งจะใช้สําหรับติดผ้ากันเปื้อนของคุณ\n              ซึ่งผู้ท่ีพบเห็นจะทราบได้ทันทีว่า\n              คุณคือ สุดยอดผู้ให้บริการที่รับรองผลงาน\n              โดย BeNeat และคุณมีผลงานความโดดเด่น\n            "
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { attrs: { id: "ways-to-great-service" } }, [
        _c(
          "div",
          { staticClass: "top-description", attrs: { "data-aos": "fade-up" } },
          [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _c("h1", [_vm._v("วิธีเป็นผู้ให้บริการยอดเยี่ยม")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n              ในทุกๆ 3 เดือนเราจะทําการประเมินว่าคุณผ่านเกณฑ์เหล่านี้ ตลอดระยะ 6 เดือนที่ผ่านมาหรือไม่"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n              ถ้าผ่านเกณฑ์ คุณก็จะได้รับ หรือ สามารถรักษาสถานะผู้ให้บริการยอดเยี่ยมไว้ได้\n            "
                    )
                  ])
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "description-content" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-6 box-one",
                  attrs: { "data-aos": "fade-up" }
                },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: "/static/img/excellent/score_more_4_8.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("h2", [_vm._v("คะแนนรวม 4.8 ขึ้นไป")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n              ผู้ให้บริการการยอดเยี่ยมจะต้องได้รับคะแนนเฉลี่ยโดยรวม อย่างน้อย 4.8\n              ขึ้นไปโดยคํานวนจากรีวิวของลูกค้าของคุณ\n            "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-6 box-two",
                  attrs: { "data-aos": "fade-up" }
                },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: "/static/img/excellent/service_minimum_2.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(
                      "การให้บริการอย่างน้อย เดือนละ 2 ครั้ง ตลอด 6 เดือนที่ผ่านมา"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n              ผู้ให้บริการจะต้องรักษาระดับจํานวนครั้งในการให้บริการอย่างน้อย 2 ครั้ง ในทุกๆเดือน\n              เพื่อเป็นการรักษาระดับฝีมือการให้บริการให้คงที่ และสร้างความมั่นใจให้กับลูกค้าของคุณว่า\n              คุณมีการให้บริการอย่างต่อเนื่องผ่านระบบของ BeNeat\n            "
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-5" }, [
              _c(
                "div",
                {
                  staticClass: "col-6 box-three",
                  attrs: { "data-aos": "fade-up" }
                },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: "/static/img/excellent/dont_cancel.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(
                      "ไม่เคยยกเลิกงานตลอด 6 เดือนที่ผ่านมา (รับงานแล้วไปไม่ได้)"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n              คุณต้องไม่เคยยกเลิกงานที่รับไปแล้วตลอด 6 เดือนที่ผ่านมา\n              (ยกเว้นกรณีเหตุสุดวิสัย ซึ่งได้ติดต่อทาง Admin และได้รับการอนุโลมจาก BeNeat แล้ว)\n              ซึ่งเป็นเรื่องสําคัญ เพราะคุณลูกค้าต้องการความมั่นใจว่า\n              การจองบริการกับคุณ จะไม่ถูกคุณยกเลิกโดยไม่มีเหตุผลอันสมควร\n            "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-6 box-four",
                  attrs: { "data-aos": "fade-up" }
                },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: "/static/img/excellent/no_report.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(
                      "ได้รับการร้องเรียนไม่เกิน 2 ครั้งตลอด 6 เดือนที่ผ่านมา"
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-438127b8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-438127b8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/ExcellentProvider.vue
// module id = 1624
// module chunks = 0